import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { ReportType } from '../reports/reports.constants';
import { AutomatedReport } from './automatedReports.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/automatedReports');

export const getAutomatedReportsList = actionCreator.async<ReportType, AutomatedReport[]>('GET_AUTOMATED_REPORTS_LIST');

export const createAutomatedReports = actionCreator.async<
  { data: Partial<AutomatedReport>; reportType: ReportType },
  AutomatedReport
>('CREATE_AUTOMATED_REPORT');

export const updateAutomatedReports = actionCreator.async<
  { data: Partial<AutomatedReport>; reportType: ReportType },
  AutomatedReport
>('UPDATE_AUTOMATED_REPORT');

export const deleteAutomatedReports = actionCreator.async<{ id: string; reportType: ReportType }, {}>(
  'DELETE_AUTOMATED_REPORT',
);
